import * as React from 'react';

import { Image, Layout, Loader, Notification, SenseBanner } from 'components';
import { ParticipantForm, Recipient } from './components';

import { P2PForm } from 'pages/P2P/components';
import { TEXT } from 'texts';
import { alienImage } from 'images';
import { observer } from 'mobx-react-lite';
import { useStores } from 'hooks';
import { useBreakpoints } from "utils";

const Main = () => {
  const { dataStore, errorStore } = useStores();
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const { isMd } = useBreakpoints()

  const initApp = async () => {
    try {
      setIsLoading(true);
      const data = await dataStore.getAppData();
      dataStore.setAppData(data);
    } catch (error) {

      errorStore.setError({
        title: TEXT.error,
        description: (error as Error).message,
        callback: initApp,
      });
    } finally {
      setIsLoading(false);
    }
  };

  React.useEffect(() => {
    initApp();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (dataStore.isClosed)
    return (
      <Notification image={<Image {...alienImage} />} title={TEXT.notActive} description={TEXT.closedDescription} />
    );

  return (
    <>
      {isLoading && <Loader />}
      {dataStore.isActive && (
        <>
          <SenseBanner/>
          <Layout
              header={<Recipient size={isMd ? "large" : "medium"} />}
              main={dataStore.hasParticipants ? <ParticipantForm /> : <P2PForm />}
          />
        </>
      )}
    </>
  );
};

export default observer(Main);
